import React from 'react';
import { useNavigate } from 'react-router-dom';
import PopupSample from '../Popup_sample';
import { formatPriceWithEuro } from '../../utils/StringUtils';
import recusTop from '../../styles/img/recus-top.png';
import chevronRight from '../../styles/img/arrow/vector.svg';

import InvoiceButton from '../../components/facture/dowloadPdf';
import { calculateTotalToPay } from '../../utils/order/orderUtils';

const InvoiceCard = ({ cartItems }) => {
  const navigate = useNavigate();

  const [viewArticle, setViewArticle] = React.useState(false);
  const [popup, setPopup] = React.useState(false);

  const store = cartItems?.storeInfo;

  const handlepopup = () => setPopup(!popup);

  const getCartLength = (cartItems) => {
    return Array.isArray(cartItems?.orderItems)
      ? cartItems.orderItems.reduce(
          (total, product) => total + (product.Qty || 0)
          , 0)
      : 0;
  };

  const itemNumber = getCartLength(cartItems);

  return (
    <>
      {popup ? (
        <PopupSample
          Title="Pikko Compte"
          Text="Crée ton compte PikkoPay et accède à de nombreux avantages !"
          List={[
            'Historique des tickets',
            'Points de fidélité',
            'Promotions exclusives',
          ]}
          Button="Me connecter / M'inscrire"
          click={() => navigate('/account')}
          close={handlepopup}
        />
      ) : null}

      <div
        className="recus relative flex flex-col justify-center items-center w-[90%] px-8 pt-10 pb-10 rounded-[8px] gap-6 text-2xl rounded-bl-none rounded-br-none"
        style={{ backgroundColor: '#FFF', fontFamily: 'geomanistbold' }}
      >
        <img src={recusTop} alt="recusTop" className="recusTop" />
        <div className="flex justify-start w-full  gap-2 items-center">
          <div className="flex items-center p-2 bg-stone-900 w-[fit-content] rounded-[10px]">
            <img
              className="h-[35px] w-[35px] object-contain"
              src={store?.logo}
              alt={store?.name}
            />
          </div>
          <p className="text-[16px] font-bold w-[fit-content] p-2 text-center rounded-[0.5em] ">
            {store?.name}
          </p>
        </div>
        <div className="line_invoice top" />
        <div className="w-full">
          <div
            className="article_count"
            onClick={() => setViewArticle(!viewArticle)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                setViewArticle(!viewArticle);
              }
            }}
          >
            <p className="">
              {' '}
              {itemNumber} Produit(s)
              <img
                className="chevron-bas opacity-45"
                src={chevronRight}
                alt="chevronBottom"
              />
            </p>
            <p className="">
              {' '}
              {formatPriceWithEuro(calculateTotalToPay(cartItems.itemsPrice, cartItems.promoPrice, cartItems?.jackpot?.amount))}
            </p>
          </div>
          {cartItems.orderItems.map((item, index) => (
            <div
              key={index}
              className={
                viewArticle ? 'article_view' : 'article_view article_hidden'
              }
            >
              <p className="">{item.name} </p>
              <p>
                {item.promoPrice && item.promoPrice > 0 ? (
                    <>
                    <span className="line-through text-gray-400 text-[1.2rem]">
                      {formatPriceWithEuro(item.price)}
                    </span> {' '}
                    <span className="">
                      {formatPriceWithEuro(item.promoPrice)}
                    </span>
                    </>
                  ) :
                  <span className="">
                    {formatPriceWithEuro(item.price)}
                  </span>
                }
                x {item.Qty ? item.Qty : ''}
              </p>
            </div>
          ))}
        </div>
        <div className={viewArticle ? '' : 'line_invoice middle'}/>

        <div className="flex items-center justify-between !w-full font-light ">
          <p className="recus_titre">Order ID </p>
          <p> &nbsp; #{cartItems._id.slice(10)} </p>
        </div>
        {cartItems?.externalInvoiceId && (
          <div className="flex items-center justify-between !w-full font-light ">
            <p className="recus_titre">Numéro de facture</p>
            <p> &nbsp; {cartItems.externalInvoiceId.replace('undefined', '')}</p>
          </div>
        )}
        <div className="flex items-center justify-between w-full font-light">
          <p className="recus_titre">Méthode</p>
          <p> &nbsp;{cartItems.paymentMethod} </p>
        </div>
        <div className="flex items-center justify-between w-full font-light">
          <p className="recus_titre">Date </p>
          <p>
            {' '}
            &nbsp; {cartItems.updatedAt.substring(8, 10)}/
            {cartItems.updatedAt.substring(5, 7)}/
            {cartItems.updatedAt.substring(0, 4)}
          </p>
        </div>

        <div className="flex items-center justify-between w-full font-light">
          <p className="recus_titre">Heure </p>
          <p>
            {' '}
            &nbsp; {Number.parseInt(cartItems.updatedAt.substring(11, 13)) + 1}:
            {cartItems.updatedAt.substring(14, 16)}{' '}
          </p>
        </div>

        <div className="line_invoice !bottom-[0]"/>
      </div>

      {store?.name?.toLowerCase().includes('match') ? (
        <InvoiceButton invoiceData={{ store, cartItems }} />
      ) : null}
    </>
  );
};

export default InvoiceCard;
